import { render, staticRenderFns } from "./BaseMenuItem.vue?vue&type=template&id=b5ea35c2&scoped=true&"
import script from "./BaseMenuItem.vue?vue&type=script&lang=js&"
export * from "./BaseMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseMenuItem.vue?vue&type=style&index=0&id=b5ea35c2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ea35c2",
  null
  
)

export default component.exports